<template>
  <!-- 登录界面 -->
  <RouterView v-if="!userStore.isLogin"/>

  <el-container class="root" v-if="userStore.isLogin">
    <el-aside width="15vw">
      <NavBar class="navbar"/>
    </el-aside>
    <el-container>
      <el-header height="40px">
        <HeaderBar />
      </el-header>
      <el-main>
        <RouterView />
      </el-main>
      <el-footer>
        <FooterBar />
      </el-footer>
    </el-container>
  </el-container>
</template>

<script setup>
import NavBar from "@/components/NavBar";
import { useStore } from "@/store/user";
import HeaderBar from "@/components/HeaderBar";
import FooterBar from "@/components/FooterBar";

const userStore = useStore();

</script>

<style scoped>
.root {
  min-height: 100vh;
}

.el-aside {
  position: relative;
}

.navbar {
  position: fixed;
  width: 15vw;
}

.el-header {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
</style>
